import { render } from "./AdvisorEdit.vue?vue&type=template&id=21d015b5"
import script from "./AdvisorEdit.vue?vue&type=script&lang=js"
export * from "./AdvisorEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__